export const sm = 640;
export const md = 768;
export const lg = 1024;

